import { FormattedMessage } from 'react-intl'
import { useQuery, gql } from '@apollo/client'

import { isEmpty } from 'lodash'

import { SelectTags } from 'components/v2/SelectTags'

const GET_ROLES_AUTOCOMPLETE = gql`
  query GetRolesAutocomplete($limit: Int!, $companyId: ID) {
    roles(pagination: { size: $limit, page: 0 }, input: { companyID: $companyId }) {
      items {
        id
        name
        permissions {
          id
          name
        }
      }
    }
  }
`

export const MultiRoleAutocomplete = (props: TSFixMe): TSFixMe => {
  let variables = {
    limit: 1000
  }

  if (props.companyId) {
    variables = {
      ...variables,
      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      companyId: props.companyId
    }
  }

  const { data } = useQuery(GET_ROLES_AUTOCOMPLETE, {
    variables
  })

  const getFilteredRoles = (): TSFixMe => {
    if (data && data.roles && !isEmpty(data.roles.items)) {
      const selectedRolesId = props.selectedRoles.map(({ id }: TSFixMe): TSFixMe => id)

      return data.roles.items.filter((role: TSFixMe): TSFixMe => {
        return selectedRolesId.indexOf(role.id) === -1
      })
    }

    return []
  }

  return (
    <SelectTags
      id={props.id}
      values={props.selectedRoles}
      items={getFilteredRoles()}
      getTagLabel={({ name }): TSFixMe => name}
      onChange={props.onChange}
      onBlur={props.onBlur}
      label={<FormattedMessage id="dictionary.roles" defaultMessage="Roles" />}
    />
  )
}
